import { InjectionToken } from '@angular/core';

export interface CachedTranslateLoaderConfig {
  fileName?: string;
}

export const CACHED_TRANSLATE_LOADER_CONFIG =
  new InjectionToken<CachedTranslateLoaderConfig>(
    'CACHED_TRANSLATE_LOADER_CONFIG',
  );
